export const LOAD_LINKS = "header.loadLinks";
